export default function WhyTheClub() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Fast & Private Sessions',
      description: 'Discreet, efficient treatments in your own luxurious suite. No waiting rooms.',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Expert Nurse Practitioners',
      description: 'Customized IV formulations administered by licensed registered nurses.',
    },
    {
      icon: 'ri-sparkling-line',
      title: '24/7 Availability',
      description: 'Available around the clock to provide you with premium wellness support.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Quick Recovery & Glow',
      description: 'Feel revitalized, energized, and radiant from the inside out.',
    },
  ];

  return (
    <section className="py-28 px-6 lg:px-12 bg-[#f9f7f4]">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-5">
            The Experience
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-charcoal tracking-tight mb-5">
            Why the Club
          </h2>
          <div className="w-16 h-px bg-gold mx-auto mb-6"></div>
          <p className="text-greige text-base font-light leading-relaxed max-w-xl mx-auto">
            IV hydration reimagined as an elevated wellness ritual — where medical expertise meets spa-like comfort.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#e8e2da]">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-[#f9f7f4] px-8 py-12 flex flex-col items-center text-center group hover:bg-white transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-3xl text-gold`}></i>
              </div>
              <div className="w-6 h-px bg-gold mb-5"></div>
              <h3 className="text-sm font-light text-charcoal mb-3 tracking-[0.1em] uppercase">
                {benefit.title}
              </h3>
              <p className="text-greige text-sm font-light leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Our Goal Section */}
        <div className="mt-20 bg-white border border-[#e8e2da] px-12 py-14 text-center max-w-3xl mx-auto">
          <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-5">
            Our Goal
          </p>
          <div className="w-12 h-px bg-gold mx-auto mb-7"></div>
          <p className="text-charcoal text-base font-light leading-relaxed mb-5">
            We know the needle is often the hardest part — and that's exactly why we've made it our mission to get it right the <strong className="font-normal italic">first time, every time.</strong>
          </p>
          <p className="text-greige text-sm font-light leading-relaxed mb-5">
            Unlike many other IV bars where patients are poked multiple times before a successful placement, our highly experienced team has spent years mastering the art of IV insertion. Precision, patience, and your comfort are at the center of everything we do.
          </p>
          <p className="text-greige text-sm font-light leading-relaxed">
            From the moment you sit down to the moment your drip is complete, our goal is simple — a painless, seamless experience that leaves you feeling better than when you walked in.
          </p>
        </div>

      </div>
    </section>
  );
}
